import styles from "./index.module.scss";
import { MoreSvg } from "@/assets/icons";
import { MoreMenu } from "@/components";
import { debounce } from "@/utils";
import clsx from "clsx";
import { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

const MoreButton = () => {
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const timeoutIdRef = useRef<any>();
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [menuPosition, setMenuPosition] = useState({ left: 0, bottom: 0 });
  const [isInResize, setIsInResize] = useState(false);
  useEffect(() => {
    const handleEndResize = debounce(() => {
      setIsInResize(false);
    }, 500);
    const handleScroll = debounce(() => {
      setIsInResize(true);
      const rect = buttonRef.current?.getBoundingClientRect();
      if (rect) {
        const { left, width, bottom } = rect;
        const menuLeft = left - 236 - 10;
        const menuBottom = window.innerHeight - bottom;
        setMenuPosition({ left: menuLeft, bottom: menuBottom });
      }
      handleEndResize();
    }, 100);

    handleScroll();
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("resize", handleScroll);
      clearTimeout(timeoutIdRef.current);
    };
  }, []);
  const handleMouseEnter = () => {
    clearTimeout(timeoutIdRef.current);
    setMenuVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutIdRef.current = setTimeout(() => {
      setMenuVisible(false);
    }, 500);
  };

  return (
    <button
      className={clsx(styles["more_button"], "circle_button")}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={buttonRef}
    >
      <MoreSvg></MoreSvg>

      {menuVisible &&
        !isInResize &&
        ReactDOM.createPortal(
          <div
            className={styles["more_menu_wrapper"]}
            style={{
              position: "fixed",
              left: menuPosition.left,
              bottom: menuPosition.bottom,
              zIndex: 1000,
            }}
          >
            <MoreMenu></MoreMenu>
          </div>,
          document.body
        )}
    </button>
  );
};

export default MoreButton;
